// extracted by mini-css-extract-plugin
export default {"container":"ghEazGQvJXspdvUBnGqb","title":"U7ZHZOKpKsFp5yza_MH3","description":"z7yvbbAsr7lwE9gdqFil"};